import Vue from 'vue';
export default Vue.extend({
    components: {
        'Swiper': function () { return import(/* webpackChunkName: "Layout-Swiper" */ '@app/components/Layout/Swiper.vue'); },
    },
    props: {
        images: {
            type: Array,
            default: function () { return []; }
        },
        activeIndex: {
            type: Number,
            default: null
        },
        captions: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            loaded: this.images.map(function () { return false; }),
            swiperOptions: {
                breakpoints: {
                    768: {
                        slidesPerView: 1
                    }
                },
                keyboard: {
                    enabled: true,
                },
            }
        };
    },
    created: function () {
        document.addEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    destroyed: function () {
        document.removeEventListener('keydown', this.handleGlobalKeyDownEvent);
    },
    methods: {
        close: function () {
            this.$emit('update:activeIndex', null);
            this.$emit('closed');
        },
        handleGlobalKeyDownEvent: function (e) {
            if (e.keyCode == 27 /* ESC */) {
                this.close();
            }
        }
    },
    watch: {
        activeIndex: function (newVal) {
            if (newVal !== null) {
                document.body.classList.add('js-active');
            }
            else {
                document.body.classList.remove('js-active');
                this.loaded = this.images.map(function () { return false; });
            }
        },
    }
});
